import { useDispatch } from 'react-redux';
import { setProfileViewing } from '../../../Redux/store';
import ProfileRow from '../../../components/ProfileRow';

function SharedOvulationUser({ prediction }) {
  const dispatch = useDispatch();

  const { ownerId, ownerName, ownerImages, ovulationActual, ovulationPrediction } = prediction;

  const subtitle = ovulationActual ? 'Actual ovulation' : (ovulationPrediction ? 'Predicted ovulation' : 'Ovulation');

  const profile = {
    id: ownerId,
    name: ownerName,
    images: ownerImages,
  };

  return (
    <li
      onClick={() => dispatch(setProfileViewing({ id: ownerId, tab: 'calendar' }))}
      className={`flex items-center rounded-xl p-3 cursor-pointer transition-colors ${
        ovulationActual
          ? 'bg-purple-100 hover:bg-purple-200'
          : 'bg-secondary hover:bg-secondary/80'
      }`}
    >
      <ProfileRow profile={profile} size="md" subtitle={subtitle} />
    </li>
  );
}

export default SharedOvulationUser;
